// i18n-disable-file 文件中的中文是字典 key，由消费方使用 $t() 翻译
import { logo } from './defaultConfig';
import HighlightText from '@/components/highlight-text';
export const columns = [{
    label: '企业名称',
    columnKey: 'full_name',
    width: 188,
    render(h, props) {
        const value = props.row.full_name || '-';
        const directives = [
            {
                name: 'tip',
                value: `full_name${props.index}`,
                kind: 'small',
                modifiers: {
                    hover: true,
                },
            },
        ];
        return (
            <div class="fullName">
                <img src={props.row.avatar || logo} class="logo"/>
                <span class="table-cell-content" {...{ directives }}>
                    <HighlightText class="list-item-name" text={value} keywords={this.searchKeyWord} />
                </span>
                <v-tip
                    ref={`full_name${props.index}`}
                    placement="top"
                    kind="small"
                >
                    {value}
                </v-tip>
            </div>
        );
    },
},
{
    label: '所属行业',
    columnKey: 'industry',
    render(h, props) {
        const value = props.row.industryText || '-';
        const directives = [
            {
                name: 'tip',
                value: `industry${props.index}`,
                kind: 'small',
                modifiers: {
                    hover: true,
                },
            },
        ];
        return (
            <div>
                <span class="table-cell-content" {...{ directives }}>{value}</span>
                <v-tip
                    ref={`industry${props.index}`}
                    placement="top"
                    kind="small"
                >
                    {value}
                </v-tip>
            </div>
        );
    },
},
{
    label: '联系电话',
    columnKey: 'phone',
    render(h, props) {
        const value = props.row.phone || '-';
        const directives = [
            {
                name: 'tip',
                value: `phone${props.index}`,
                kind: 'small',
                modifiers: {
                    hover: true,
                },
            },
        ];
        return (
            <div>
                <span class="table-cell-content" {...{ directives }}>{value}</span>
                <v-tip
                    ref={`phone${props.index}`}
                    placement="top"
                    kind="small"
                >
                    {value}
                </v-tip>
            </div>
        );
    },
},
{
    label: '企业地址',
    columnKey: 'address',
    render(h, props) {
        const value = props.row.addressText || '-';
        const directives = [
            {
                name: 'tip',
                value: `address${props.index}`,
                kind: 'small',
                modifiers: {
                    hover: true,
                },
            },
        ];
        return (
            <div>
                <span class="table-cell-content"  {...{ directives }}>{value}</span>
                <v-tip
                    ref={`address${props.index}`}
                    placement="top"
                    kind="small"
                >
                    {value}
                </v-tip>
            </div>
        );
    },
},
{
    label: '电子邮箱',
    columnKey: 'email',
    minWidth: 150,
    render(h, props) {
        const value = props.row.email || '-';
        const directives = [
            {
                name: 'tip',
                value: `email${props.index}`,
                kind: 'small',
                modifiers: {
                    hover: true,
                },
            },
        ];
        return (
            <div>
                <span class="table-cell-content"  {...{ directives }}>{value}</span>
                <v-tip
                    ref={`email${props.index}`}
                    placement="top"
                    kind="small"
                >
                    {value}
                </v-tip>
            </div>
        );
    },
},
{
    label: '企业主页',
    columnKey: 'ehome',
    minWidth: 154,
    render(h, props) {
        const value = props.row.home || '-';
        const directives = [
            {
                name: 'tip',
                value: `ehome${props.index}`,
                kind: 'small',
                modifiers: {
                    hover: true,
                },
            },
        ];
        return (
            <div>
                <span class="table-cell-content"  {...{ directives }}>{value}</span>
                <v-tip
                    ref={`ehome${props.index}`}
                    placement="top"
                    kind="small"
                >
                    {value}
                </v-tip>
            </div>
        );
    },
},
];
export const mainInfoList = [
    {
        text: '企业全称',
        key: 'eFullName',
    },
    {
        text: '企业ID',
        key: 'id',
    },
    {
        text: '联系电话',
        key: 'ePhone',
    },
    {
        text: '所属行业',
        key: 'eIndustry',
    },
    {
        text: '电子邮箱',
        key: 'eEmail',
    },
    {
        text: '企业地址',
        key: 'eAddress',
    },
];
